import {useEffect, useState, useRef} from 'react';
import {withRouter} from 'react-router-dom';
import {Breadcrumb, Col, Container, Row} from 'react-bootstrap';
import GoogleMaps from '../partials/GoogleMaps';
import Api from '../../services/Api';
import HelperGeneral from '../../helpers/HelperGeneral';
import {Button, Form, Input, notification, Select} from 'antd';

const {Option} = Select;

const SalesPoints = () => {
    const formRef = useRef(null);
    const [pharmacies, setPharmacies] = useState([]);
    const [pharmaciesMap, setPharmaciesMap] = useState([]);
    const [loading, setLoading] = useState([]);
    const [cities, setCities] = useState([]);
    const [counties, setCounties] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState(undefined);
    const [success, setSuccess] = useState(undefined);
    const [searchLoading, setSearchLoading] = useState(false);

    const getCounties = (cityId) => {
        setLoading(true);
        formRef.current?.resetFields(['countyId']);
        setCounties([]);

        Api.getCounties(cityId).then((e) => {
            setLoading(false);
            setCounties(e?.data);
        }).catch(e => {
            HelperGeneral.alert(e);
            setLoading(false);
        })
    }

    useEffect(() => {
        setLoading(true);

        Api.getCitiesAll().then((e) => {
            setLoading(false);
            setCities(e?.data);
        }).catch(e => {
            HelperGeneral.alert(e);
            setLoading(false);
        })
    }, [])

    const onFinishSalesFilter = (values) => {
        setSearchLoading(true);

        let searchKey = (values?.searchKey || values?.searchKey?.length > 0) ? values?.searchKey : "";
        let cityId = values?.cityId ?? "";
        let countyId = values?.countyId ?? "";

        if ((searchKey === "") && (cityId === "") && (countyId === "")) {
            setSearchLoading(false);
            notification['error']({
                message: 'Hata!',
                description: 'Lütfen eczane ismi giriniz veya il seçiniz',
            });
        } else {
            let data = {
                store_filter: [
                    {
                        brand: "",
                        city: cityId,
                        company_name: searchKey,
                        county: countyId,
                        id: "0"
                    }
                ],
                type: 2,
                shipping_methods: "0"
            }

            Api.getPharmacies(data).then((e) => {
                let pharmaciesList = e?.data;

                setPharmaciesMap(pharmaciesList);
                setPharmacies(pharmaciesList);
                setSuccess(true);
                setSearchLoading(false);
                HelperGeneral.scrollToClassName('.google-maps');
            }).catch(e => {
                HelperGeneral.alert(e);
                setSearchLoading(false);
            })
        }
    }

    return (
        <div className={'my-account product-category sales-points pb-3 pb-sm-5 min-height-container basket'}>
            <Container>
                <Row>
                    <Col xs={12}>
                        <h4>Yetkili Eczaneler</h4>
                        <Breadcrumb>
                            <Breadcrumb.Item href={"/home"}>Ana Sayfa</Breadcrumb.Item>
                            <Breadcrumb.Item>Yetkili Eczaneler</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                    <Col xs={12} className={'mt-0 mt-sm-4'}>
                        <div className={'sales-points-div orders'}>
                            <p>
                                Yetkili eczaneleri görmek için eczane ismi veya il ve ilçe bilgisini giriniz.
                            </p>
                            <Form
                                layout={"vertical"}
                                name={""}
                                ref={formRef}
                                onFinish={(e) => {
                                    return onFinishSalesFilter(e)
                                }}
                            >
                                <Row>
                                    <Col xs={12} md={3}>
                                        <Form.Item
                                            name={"cityId"}
                                            rules={[{required: false}]}
                                        >
                                            <Select
                                                placeholder={'İl Seçiniz'}
                                                className={'w-100'}
                                                loading={loading}
                                                onChange={(value) => {
                                                    if (value !== undefined) {
                                                        getCounties(value);
                                                    } else {
                                                        formRef.current?.resetFields(['countyId']);
                                                    }
                                                    setSelectedCountry(value);
                                                }}
                                                allowClear={true}
                                                showSearch={true}
                                                filterOption={(input, option) =>
                                                    option?.children?.toLocaleLowerCase('tr')?.includes(input?.toLocaleLowerCase('tr'))
                                                }
                                            >
                                                {
                                                    cities?.map((v, i) => (
                                                        <Option value={v?.id} key={i}>{v?.title}</Option>
                                                    ))
                                                }
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={12} md={3}>
                                        <Form.Item
                                            name={"countyId"}
                                            rules={[{required: false}]}
                                        >
                                            <Select
                                                placeholder={'İlçe Seçiniz'}
                                                className={'w-100'}
                                                loading={loading}
                                                disabled={selectedCountry === undefined}
                                                allowClear={true}
                                                showSearch={true}
                                                filterOption={(input, option) =>
                                                    option?.children?.toLocaleLowerCase('tr')?.includes(input?.toLocaleLowerCase('tr'))
                                                }
                                            >
                                                {
                                                    counties?.map((v, i) => (
                                                        <Option value={v?.id} key={i}>{v?.title}</Option>
                                                    ))
                                                }
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={12} md={3}>
                                        <Form.Item
                                            name={"searchKey"}
                                            rules={[{required: false}]}
                                        >
                                            <Input placeholder={'Eczane İsmi'}/>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={12} md={3}>
                                        <Form.Item>
                                            <Button
                                                type={"primary"}
                                                htmlType={"submit"}
                                                className={'btn text-white btn-primary w-100'}
                                                style={{
                                                    border: 'none',
                                                    borderRadius: 3,
                                                    height: 46,
                                                }}
                                                loading={searchLoading}
                                            >
                                                Yetkili Eczaneleri Bul
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                            <Row>
                                <Col xs={12} className={'mt-1 mt-sm-4 google-maps'}>
                                    <GoogleMaps markers={pharmaciesMap}/>
                                </Col>
                            </Row>
                            {
                                (pharmacies?.length < 1 && success === true) && (
                                    <Row>
                                        <Col xs={12} className={'mt-4'}>
                                            <h3 className={'pb-0'}>
                                                Aradığınız kriterlere uygun eczane bulunamadı.
                                            </h3>
                                        </Col>
                                    </Row>
                                )
                            }
                            {
                                pharmacies?.length > 0 && (
                                    <Row>
                                        <Col xs={12} className={'mt-4'}>
                                            <h3 className={'pb-2 pb-sm-3'}>
                                                Aradığınız kriterlere uygun {pharmacies?.length} eczane bulundu.
                                            </h3>
                                            <Container className={'p-0'}>
                                                {
                                                    pharmacies?.map((v, i) => (
                                                        <Row className={`pharmacy-row pharmacy-${i + 1}`} key={i}>
                                                            <Col xs={12} className={'d-flex justify-content-start align-items-center'}>
                                                                <Row className={'h-100'}>
                                                                    <Col xs={12}>
                                                                        <div className={'d-flex flex-row justify-content-start align-items-center'}>
                                                                            <b>{v?.name}</b> {(v?.latitude && v?.longitude) && <span className={'marker'}>{i + 1}</span>}
                                                                        </div>
                                                                    </Col>
                                                                    <Col xs={12}>
                                                                        {v?.address?.length > 0 ? v?.address : '-'}
                                                                    </Col>
                                                                    <Col xs={12}>
                                                                        {v?.telephone?.length > 0 ? v?.telephone : '-'}
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                    ))
                                                }
                                            </Container>
                                        </Col>
                                    </Row>
                                )
                            }
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default withRouter(SalesPoints);
